import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col } from "antd";
import {
  intersectionBy,
  flatMap,
  sortBy,
  differenceWith,
  isEqual
} from "lodash";
import ScheduleGrant from "../ScheduleGrant/ScheduleGrant";
import GrantAllocation from "../GrantAllocation/GrantAllocation";
import OneTimeGrants from "../OneTimeGrants/OneTimeGrants";
import RecurringGrants from "../RecurringGrants/RecurringGrants";
import {
  SectionMediumDivider,
  Note,
  ItemHeading,
  AlertWrap
} from "../../style";
import {
  receiveAllocationTableData,
  changeScheduleAllocation,
  cancelGrantFlow,
  fetchPoolsPendingAdminFee
} from "../../actions";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import GrantAllocationTable from "../GrantAllocationTable/GrantAllocationTable";
import FlowFooter from "../FlowFooter/FlowFooter";
import { SectionContent, CommonListWrapper } from "../../../../../../CommonComponents/commonStyles";
import {
  startDate,
  todayDate,
  formatAmount,
  moveIntoErrorPosition
} from "../../../../../../utils/commonUtil";
import {
  ContentProvider,
  Types,
  ContentMessage,
  AlertContent
} from "../../../../../../CommonComponents/ContentMessages";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { isGeminiUser } from "../../../../../../utils/sessionUtil";
import { scheduleAllocationDerivedStates } from '../../Selectors/ScheduleAllocationSelectors';
import { replaceSelect } from "../../../../../../utils/replacer";
import { allocationCalculator } from "../../utils";
import { ErrorModal } from "../ViewEditSchedules/Components/Errors";


export class GrantScheduleAllocation extends Component {
  constructor(props) {
    super(props);
    const lowBalCheck = this.lowBalCheck(
      this.getAvailableBalance(),
      props.fromEdit
    );
    this.myRef = React.createRef();
    this.state = {
      scheduleType: props.selectedSchedule || "oneTime",
      grantAmount: this.getInitialBalance(
        props.selectedAmount,
        this.getAvailableBalance(),
        props.fromEdit
      ),
      allocationPref: this.getInitialAllocType(
        props.selectedAllocType,
        this.getAvailableBalance(),
        props.fromEdit
      ),
      startDate: props.selectedDate || "",
      frequency: props.selectedFrequency || "",
      noOfPayments: props.selectedNoOfPayments || 0,
      allocations: [],
      scheduleFormValid: lowBalCheck,
      showScheduleConfirm: false,
      scheduleTypeChange: "",
      grantAmountLocked: lowBalCheck,
      showPercentageExceedFlag: false,
      showLowGrantAmountFlag: false,
      status: props.status,
      allSharesAllPools: props.selectedAllSharesAllPools || false,
      allShares: props.selectedAllShares || false,
      submitWarningPopup: false,
      allocationFormValid: false,
      individualValidator: false,
      button1: "",
      button2: "",
      weightedAllocEdit: false,
      allocPrefState: false,
      entireBalPopup: false
    };
  }

  componentDidMount() {
    // If grantId is populated (for edit and regrant pass it to API) for bug 6366 & 6425
    // For spawn, grant template id needs to be passed
    let grantIdParam = "";
    // Bug 6617 - Do not pass grant id incase of regrant flow
    if (this.props.fromEdit && !this.props.isRegrantFlow) {
      const id = Number(this.props.grantId) || this.props.grantTemplateId;
      grantIdParam = id ? `&grantId=${id}` : "";
    }
    this.props.receiveAllocationTableData({
      method: "GET",
      url: `/donor-portal/api/investment/${
        this.props.accountId
      }/findInvestmentPoolsForGrantSubmitByAccountIdStartDateAndEndDate?startDateStr=${startDate(
        7
      )}&endDateStr=${todayDate()}${grantIdParam}`,
      page: "recommendGrant"
    });
        window.scrollTo(0, 0);
    
  }

  // bugfix 6494 - when in edit grant flow available balance should acc bal + grant amount
  getAvailableBalance = () => {
    let availableBalance = Number(this.props.availableBalance);
    if (this.props.fromEdit) {
      availableBalance =
        Number(this.props.availableBalance) + Number(this.props.selectedAmount);
    }
    return availableBalance.toFixed(2);
  };

  getPoolsPendingContribAndFee(successFn) {
    this.props.fetchPoolsPendingAdminFee(
      { userId: this.props.accountId },
      successFn
    );
  }

  getInitialBalance = (amount, availableBalance, editMode) => {
    if (amount) {
      return amount.toString();
    }
    if (this.lowBalCheck(availableBalance, editMode)) {
      return availableBalance.toString();
    }
    return "";
  };

  getInitialAllocType = (selectedType, availableBalance, editMode) => {
    if (selectedType) {
      return selectedType;
    }
    if (this.lowBalCheck(availableBalance, editMode)) {
      return "entireBalance";
    }
    return "weightedAllocations";
  };

  checkSchedulePropChange = () => {
    if (this.state.scheduleType === "oneTime") {
      return (
        (this.state.grantAmount === 0 || this.state.grantAmount === "") &&
        this.state.startDate === ""
      );
    } else {
      return (
        this.state.frequency === "" &&
        this.state.startDate === "" &&
        this.state.noOfPayments === ""
      );
    }
  };

  // When account available balance is less than 500, then all shares all pools would be selected by default
  lowBalCheck = (availableBalance, editMode) => {
    const minAmount = 500;
    if (editMode) {
      return false;
    }
    return Number(availableBalance) < Number(minAmount);
  };

  handleScheduleTypeChange = event => {
    const selectedType = event.target.value;
    if (this.checkSchedulePropChange()) {
      this.confirmScheduleTypeChange(event, selectedType);
    } else {
      this.setState({
        showScheduleConfirm: true,
        scheduleTypeChange: selectedType
      });
    }
  };

  // reset form on schedule type change
  // schedule change should not be possible in low balance scenario
  confirmScheduleTypeChange = (e, selectedType) => {
    const { analyticsHandler, stepDesc } = this.props;
    analyticsHandler &&
      stepDesc &&
      analyticsHandler(
        "tabsStep",
        `Step 2 ${stepDesc}`,
        selectedType === "recurring" ? "Recurring Grant" : "One Time Grant"
      );
    this.setState(prevState => ({
      scheduleType: selectedType || prevState.scheduleTypeChange,
      grantAmount: 0,
      grantAmountLocked: false,
      startDate: "",
      frequency: "",
      noOfPayments: 0,
      showScheduleConfirm: false,
      scheduleTypeChange: "",
      scheduleFormValid: false,
      allocationPref: "weightedAllocations",
      allocations: []
    }));
  };

  cancelScheduleTypeChange = () => {
    this.setState({
      showScheduleConfirm: false,
      scheduleTypeChange: ""
    });
  };

  handleFormChange = ({ data, isFormValid, allocPref }) => {
    const {allocationPref, allocPrefState} = this.state;   
    const allocPrefChangeReq = (allocationPref === "entireBalance" && allocPref !== "weightedAllocations") || (allocationPref === "entireBalance" && !allocPrefState )|| (!allocPrefState && allocationPref === "byDollars") ? allocationPref : allocPref ;
    this.setState({
      ...data,
      scheduleFormValid: isFormValid,
      allocPrefState: true,
      allocationPref: allocPrefChangeReq || allocationPref
    });
     };

  handleAllocationPrefChange = preference => {
    this.setState({
      allocationPref: this.mapAllocationPref(preference),
      weightedAllocEdit: false,
      allocPrefState: false
    });
  };
  handleWithRespectToPopup = ()=>{
    this.setState({
      allocationPref: this.mapAllocationPref("entireBalance"),
      weightedAllocEdit: false,
      allocPrefState: false,
      entireBalPopup: true
    },() => {this.myRef.current.handleAllPoolsOk()});    
  }

  handleAllocationChange = allocationData => {
    this.setState({
      allocations: [...allocationData.allocations],
      allocationPref: this.mapAllocationPref(
        this.state.allocationPref,
        allocationData.allocType,
        allocationData.grantAmountOrPercentFieldChange
      ),
      weightedAllocEdit: allocationData.grantAmountOrPercentFieldChange || false,
      grantAmount: allocationData.grantAmount,
      grantAmountLocked:
        this.lowBalCheck(this.getAvailableBalance(), this.props.fromEdit) ||
        allocationData.allSharesAllPools ||
        allocationData.allShares,
      allSharesAllPools: allocationData.allSharesAllPools,
      allShares: allocationData.allShares,
      allocationFormValid: allocationData.isFormValid
    });
  };

  mapAllocationPref = (allocationPref, allocType = "byDollars", grantAmountOrPercentFieldChange=false) => {
    
    if(grantAmountOrPercentFieldChange) return "byDollars"
    
    if (allocationPref === "weightedAllocations") {
      return "weightedAllocations";
    }
    if (allocationPref === "entireBalance") {
      return "entireBalance";
    }
    return allocType;
  };

  reverseMapAllocationPref = (allocType = "weightedAllocations") => {
    if(allocType === "entireBalance") {
      return "entireBalance";
    }
    if (allocType !== "weightedAllocations") {
      return "perDollarAmount";
    }
    return allocType;
  };

  submitData = () => {
    const {
      scheduleType,
      grantAmount,
      startDate,
      userSelectedDateVal,
      frequency,
      noOfPayments,
      allocationPref,
      allocations,
      allSharesAllPools,
      allShares
    } = this.state;
    this.props.changeScheduleAllocation({
      grantAmount: Number(grantAmount).toFixed(2),
      scheduleType,
      startDate,
      userSelectedDateVal,
      frequency,
      noOfPayments,
      allocationPref,
      allocations,
      allSharesAllPools,
      allShares
    });
  };



  handleSubmit = () => {
    this.setState({ individualValidator: !this.state.individualValidator });
    if (this.isEnabled()) {
      this.validateAllocations(() => {
        this.submitData();
        if (this.state.scheduleType === "recurring") {
          this.props.history.push("/grants/recommend/step2A");
        } else {
          this.props.history.push("/grants/recommend/review");
        }
      });
    } else {
      setTimeout(() => {
        moveIntoErrorPosition(".error-fields");
      }, 0);
    }
  };

  validateAllocations = successFn => {
    if (
      !allocationCalculator(
        this.state.allocations,
        this.state.allocationPref,
        this.state.grantAmount
      )
    ) {
      this.setState({
        showPercentageExceedFlag: true
      });
    } else if (
      !this.lowBalCheck(this.getAvailableBalance(), this.props.fromEdit) &&
      this.state.grantAmount < 500
    ) {
      this.setState({
        showLowGrantAmountFlag: true
      });
    } else if (this.state.allShares || this.state.allSharesAllPools) {
      window.scroll(0, 0);
      const currentAllocations = this.state.allocations;
      const allSharesAllPoolsFlow = this.state.allSharesAllPools;
      // admin Fee and pending pools api are called together because
      // in FSD it was mentioned for both all shares and all shares all pools
      // but after bug 6234, admin fee had to shown only for all shares all pools
      // breaking the call would require lot of time so calling them both
      // but displaying admin fee only for all shares all pools
      this.getPoolsPendingContribAndFee((poolsPendingContrib, adminFee) => {
        const selectedPoolsPending = intersectionBy(
          currentAllocations,
          poolsPendingContrib,
          "id"
        );
        // admin fee can be positive or negative
        const { adminFeeAmount = 0 } = adminFee;
        if (
          (allSharesAllPoolsFlow && adminFeeAmount !== 0) ||
          selectedPoolsPending.length
        ) {
          this.setState({
            submitWarningPopup: true,
            selectedPoolsPending: flatMap(selectedPoolsPending, "name"),
            submitFunc: successFn
          });
        } else {
          successFn();
        }
      });
    } else {
      successFn();
    }
  };

  confirmWarning = () => {
    this.state.submitFunc && this.state.submitFunc();
    this.setState({
      submitWarningPopup: false,
      selectedPoolsPending: [],
      submitFunc: null
    });
  };

  cancelWarning = () => {
    this.setState({
      submitWarningPopup: false,
      selectedPoolsPending: [],
      submitFunc: null
    });
  };

  percentExceedCancel = () => {
    this.setState({
      showPercentageExceedFlag: false
    });
    setTimeout(() => {
      moveIntoErrorPosition("#grant-table");
    }, 0);
  };

  lowGrantAmountCancel = () => {
    this.setState({
      showLowGrantAmountFlag: false
    });
  };

  handleUpdate = () => {
    const {
      analyticsHandler,
      onUpdate,
      stepDesc,
      editMode,
      history
    } = this.props;
    this.setState({ individualValidator: !this.state.individualValidator });

    if (editMode && this.isUpdateEnabled()) {
      this.validateAllocations(() => {
        analyticsHandler &&
          analyticsHandler(
            `${stepDesc ? "update" : "update2"}`,
            `${stepDesc ? `Step 2 ${stepDesc}` : ""}`,
            `Update - ${
              this.props.scheduleType === "recurring"
                ? `Recurring Grant`
                : `One Time Grant`
            }`
          );
        this.submitData();
        onUpdate();
      });
    } else {
      if (this.formEqual()) {
        if (stepDesc) history.push("/grants/recommend/review");
        else history.goBack();
      } else {
        setTimeout(() => {
          moveIntoErrorPosition(".error-fields");
        }, 0);
      }
    }
  };

  handleExit = () => {
    const { cancelGrantFlow, analyticsHandler, stepDesc, history } = this.props;
    cancelGrantFlow();
    analyticsHandler &&
      stepDesc &&
      analyticsHandler("exit", `Step 2 ${stepDesc}`, "Exit");
    // navigate to account summary
    history.push("/");
  };

  handleBack = () => {
    const { analyticsHandler, stepDesc, history } = this.props;
    analyticsHandler &&
      stepDesc &&
      analyticsHandler(
        "back",
        `Step 2 ${stepDesc}`,
        `Back - ${
          this.state.scheduleType === "recurring"
            ? `Recurring Grant`
            : `One Time Grant`
        }`
      );
    history.push("/grants/recommend/charity-purpose");
  };

  isEnabled = () =>
    this.state.scheduleFormValid && this.state.allocationFormValid;

  // Check the feature is avalilable by the particular csr user
  checkCsrBusiness = businessFunction => {
    return checkCSRBusinessFunction(
      BUSINESS_FUNCTION[businessFunction],
      this.props.csrBusinessFunction
    );
  };

  formEqual = () => {
    const stateVal = {
      scheduleType: this.state.scheduleType,
      grantAmount: this.state.grantAmount,
      startDate: this.state.startDate,
      frequency: this.state.frequency,
      noOfPayments: this.state.noOfPayments,
      allocationPref: this.state.allocationPref
    };
    const propsVal = {
      scheduleType: this.props.selectedSchedule,
      grantAmount: this.props.selectedAmount.toString(),
      startDate: this.props.selectedDate,
      frequency: this.props.selectedFrequency
        ? this.props.selectedFrequency
        : "",
      noOfPayments: this.props.selectedNoOfPayments
        ? this.props.selectedNoOfPayments
        : 0,
      allocationPref: this.props.selectedAllocType
    };

    // bugfix 6592 - allocations object will never be the same in case of all shares all pools
    // or all shares specific pools therefore adding a new condition for that
    const propsAlloc = sortBy(this.props.selectedAllocations, "id");
    const stateAlloc = sortBy(this.state.allocations, "id");
    let allocEqual = false;
    if (this.state.allSharesAllPools || this.state.allShares) {
      // comparing stateAlloc with propsAlloc as new pools can be added
      const diffArr = differenceWith(
        stateAlloc,
        propsAlloc,
        (stateValue, propValue) => {
          return (
            // check propValue exists
            propValue &&
            propValue.allShare &&
            stateValue.allShare === propValue.allShare &&
            propValue && propValue.id && stateValue.id === propValue.id &&
            propValue && propValue.name && stateValue.name === propValue.name
          );
        }
      );
      allocEqual = diffArr.length === 0;
    } else {
      allocEqual = isEqual(stateAlloc, propsAlloc);
    }

    return isEqual(stateVal, propsVal) && allocEqual;
  };

  isUpdateEnabled = () => {
    let csrBusiness =
      isGeminiUser() &&
      this.props.applicable_business_function &&
      this.props.applicable_business_function.length > 0
        ? !this.checkCsrBusiness(this.props.applicable_business_function[0])
        : true;

    return !this.formEqual() &&
      this.state.scheduleFormValid &&
      this.state.allocationFormValid
      ? csrBusiness
      : !this.formEqual() &&
          this.state.scheduleFormValid &&
          this.state.allocationFormValid;
  };

  isUpdateEnabledInCSR = () => {
    return isGeminiUser() &&
      this.props.applicable_business_function &&
      this.props.applicable_business_function.length > 0
      ? !this.checkCsrBusiness(this.props.applicable_business_function[0])
      : true;
  };

  isAllocationTableEnabled = () => {
      return (
      !!this.state.grantAmount ||
      this.state.allShares ||
      this.state.allSharesAllPools
    );
  };

  render() {
    const {
      page,
      allocationData,
      allocationLoading,
      grantName,
      selectedAllocations,
      enableCancelPopUp, // passed from parent page
      adminFee,
      contribAndFeeLoading,
      editMode,
      fromEdit,
      pendingSpawnId,
      keyPropertyUpdate
    } = this.props;
    const {
      scheduleType,
      grantAmount,
      allocationPref,
      showScheduleConfirm,
      showPercentageExceedFlag,
      grantAmountLocked,
      status,
      startDate,
      frequency,
      noOfPayments,
      submitWarningPopup,
      selectedPoolsPending,
      showLowGrantAmountFlag,
      allSharesAllPools,
      allShares,
      allocations,
      individualValidator,
      weightedAllocEdit,
      allocPrefState,
      entireBalPopup
    } = this.state;
    const availableBalance = this.getAvailableBalance();
    const showAdminFee = adminFee && allSharesAllPools;
    const lowBalCheck = this.lowBalCheck(availableBalance, fromEdit);
    // Avoid unnecessary method call
    const isUpdateEnabled = editMode && this.isUpdateEnabled();
    const isUpdateEnabledInCSR = editMode && this.isUpdateEnabledInCSR();
    const allocationPrefData = (allocationPref === "perDollarAmount" && (allShares || allSharesAllPools) ? "entireBalance" : allocationPref);
    return (
      <>
        <div
          className={contribAndFeeLoading ? "display-block" : "display-none"}
        >
          <Preloader />
        </div>
        <div className={contribAndFeeLoading ? "display-none" : undefined}>
          <ScheduleGrant
            disabled={editMode || lowBalCheck || this.props.isRegrantFlow}
            userTabSelected={scheduleType}
            onChange={this.handleScheduleTypeChange}
          />
          {scheduleType === "oneTime" && (
            <OneTimeGrants
              allocationData={allocationData}
              allocPrefState={allocPrefState}
              amount={grantAmount}
              amountLocked={grantAmountLocked}
              date={startDate === "—" ? null : startDate} //Offshoot of Invalid date scenario
              availableBalance={availableBalance}
              handleFormChange={this.handleFormChange}
              lowBalCheck={lowBalCheck}
              individualValidator={individualValidator}
              allShares={allShares}
              allSharesAllPools={allSharesAllPools}
              confirmWithPopup={this.handleWithRespectToPopup}
            />
          )}
          {scheduleType === "recurring" && (
            <RecurringGrants
              editMode={editMode}
              status={status}
              amount={grantAmount}
              amountLocked={grantAmountLocked}
              date={startDate}
              frequency={frequency}
              noOfPayment={noOfPayments}
              availableBalance={availableBalance}
              grantName={grantName}
              handleFormChange={this.handleFormChange}
              individualValidator={individualValidator}
            />
          )}
          <SectionMediumDivider />
          <GrantAllocation
            isEnabled={this.isAllocationTableEnabled()}
            allocationPref={this.reverseMapAllocationPref(allocationPrefData)}
            onChange={this.handleAllocationPrefChange}
            disabled={entireBalPopup || lowBalCheck}
            scheduleType={scheduleType}
            showAllSharesColumn={!pendingSpawnId}
          >
            {allocationLoading ? (
              <Preloader />
            ) : (
              <>
                <Row>
                  <Col lg={24} md={24} xs={24}>
                    <GrantAllocationTable
                      allocationData={allocationData}
                      availableBalance={availableBalance}
                      amount={grantAmount}
                      allocationPreference={allocationPrefData}
                      scheduleType={scheduleType}
                      onChange={this.handleAllocationChange}
                      allocations={selectedAllocations}
                      allSharesAllPoolsOnly={lowBalCheck}
                      allSharesAllPools={allSharesAllPools}
                      allShares={allShares}
                      // bugfix 6628 - disable all shares and all shares all pools for pending spawns
                      showAllSharesColumn={!pendingSpawnId}
                      page={"Recommend a Grant"}
                      weightedAllocEdit={weightedAllocEdit}
                      fromEdit={fromEdit}
                      ref={this.myRef}
                      entireBalPopup={entireBalPopup}
                    />
                  </Col>
                </Row>
              </>
            )}
          </GrantAllocation>     
          <ContentProvider
            types={[Types.PAGE_DISCLAIMERS]}
            pages={["Recommend a Grant - Allocation"]}
          >
            <Note>
              <ItemHeading>Please Note</ItemHeading>
              <CommonListWrapper>
                <ContentMessage
                  page="Recommend a Grant - Allocation"
                  type={Types.PAGE_DISCLAIMERS}
                  property="field_disclaimer_content"
                  html
                />
              </CommonListWrapper>
            </Note>
          </ContentProvider>
          <SectionMediumDivider />
          <FlowFooter
            data-test="flow-footer"
            page={page}
            enableCancelPopUp={enableCancelPopUp && isUpdateEnabled}
            enableUpdate={isUpdateEnabledInCSR}
            handlePrimaryCta={this.handleSubmit}
            handleSecondaryCta={this.handleBack}
            handleExitCta={this.handleExit}
            edit={editMode}
            keyProperty={page === "Edit Grant" ? "Cancel Edit Grant" : "Cancel Recommend a Grant"}
            keyPropertyUpdate={keyPropertyUpdate}
            handleUpdateCta={this.handleUpdate}
            handleUpdateCancel={() =>
              this.props.onUpdateCancel(
                this.props.stepDesc,
                2,
                this.props.scheduleType
              )
            }
            exitPopupTitle="Cancel grant recommendation"
          />

          <ErrorPopup
            title={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Schedule Change Recommend a Grant"}
                property={"field_header"}
                html={true}
                defaultMessage={"Schedule Type Change"}
                alertId="scheduleGrantPopupHeading"
              />
            }
            show={showScheduleConfirm}
            primaryCta={this.confirmScheduleTypeChange}
            secondaryCta={this.cancelScheduleTypeChange}
            primaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Schedule Change Recommend a Grant"}
                property={"field_alert_button1_text"}
                html={true}
                defaultMessage={"Ok"}
                alertId="scheduleGrantPrimaryBtn"
              />
            }
            secondaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Schedule Change Recommend a Grant"}
                property={"field_alert_button2_text"}
                html={true}
                defaultMessage={"Cancel"}
                alertId="scheduleGrantSecondaryBtn"
              />
            }
          >
            <AlertWrap>
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Schedule Change Recommend a Grant"}
                property={"field_description"}
                html={true}
                alertId="scheduleGrantPopupDesc"
                defaultMessage={"<p>Changing the schedule type will discard all the values entered so far on this step.<br /><br />\nAre you sure you want to continue?</p>"}
              />
            </AlertWrap>
          </ErrorPopup>


          <ErrorModal showModal={showPercentageExceedFlag} cancelModal={this.percentExceedCancel}/>
       
          
          <ErrorPopup
            title="Warning"
            show={submitWarningPopup}
            primaryCta={this.confirmWarning}
            primaryCtaLabel="Continue"
            secondaryCta={this.cancelWarning}
            secondaryCtaLabel="No, take me back"
          >
            {showAdminFee ? (
              <SectionContent
                className={
                  showAdminFee &&
                  selectedPoolsPending &&
                  selectedPoolsPending.length
                    ? "pb0"
                    : ""
                }
              >
                Your administrative fee credit for the current quarter-to-date
                will be applied to the grant amount.
                <p className="mb0">{`Approximate grant amount including administrative fee credit: ${formatAmount(
                  Number(grantAmount) - Number(adminFee)
                )}`}</p>
                <p className="mb0">{`Approximate administrative fee credit: ${formatAmount(
                  adminFee
                )}`}</p>
              </SectionContent>
            ) : (
              ""
            )}
            {showAdminFee &&
            selectedPoolsPending &&
            selectedPoolsPending.length ? (
              <SectionMediumDivider smallMarginTop smallMarginBottom />
            ) : (
              ""
            )}
            {selectedPoolsPending && selectedPoolsPending.length ? (
              <SectionContent>
                {`You have a pending contribution to the following pool(s): ${replaceSelect(selectedPoolsPending)}. 
                If you recommend this grant by selecting the ${
                  allocations && allocations.length > 1
                    ? "“All shares, Specific pools”"
                    : "“All shares, Specific pool”"
                } checkbox, 
                it is possible that the proceeds from your most recent contribution will be included in this grant, 
                and this grant could therefore be issued for more than you intended. 
                If this is not your intention, 
                please click “Cancel” and recommend your grant by dollar amount 
                (or wait until your contribution is completed). 
                If you have any questions, please call Vanguard Charitable at 888-383-4483.`}
              </SectionContent>
            ) : (
              ""
            )}
          </ErrorPopup>
          <ErrorPopup
            title="Error"
            show={showLowGrantAmountFlag}
            primaryCta={this.lowGrantAmountCancel}
          >
            <SectionContent>Enter a minimum of $500.</SectionContent>
          </ErrorPopup>
        </div>
      </>
    );
  }
}

export const mapDispatchToProps = dispatch => ({
  receiveAllocationTableData: payload => dispatch(receiveAllocationTableData(payload)),
  changeScheduleAllocation: payload => dispatch(changeScheduleAllocation(payload)),
  cancelGrantFlow: payload => dispatch(cancelGrantFlow(payload)),
  fetchPoolsPendingAdminFee: (payload, successFn) =>
    dispatch(fetchPoolsPendingAdminFee(payload, successFn))
});

const mapStateToProps = state => ({
  ...scheduleAllocationDerivedStates(state.toJS())
});

GrantScheduleAllocation.propTypes = {
  accountId: PropTypes.string,
  allocationType: PropTypes.string,
  analyticsHandler: PropTypes.func,
  availableBalance: PropTypes.number,
  charityBackPath: PropTypes.string,
  currentBalance: PropTypes.number,
  editMode: PropTypes.bool,
  enableCancelPopUp: PropTypes.bool,
  getAvailableBalance: PropTypes.func,
  grantAmount: PropTypes.number,
  grantPurposeName: PropTypes.string,
  grantRecognitionId: PropTypes.string,
  history: PropTypes.object,
  keyPropertyUpdate: PropTypes.string,
  location: PropTypes.object,
  newGrant: PropTypes.func,
  noOfPayments: PropTypes.number,
  onUpdate: PropTypes.func,
  onUpdateCancel: PropTypes.func,
  page: PropTypes.string,
  scheduleType: PropTypes.string,
  selectedAccountId: PropTypes.string,
  selectedAllShares: PropTypes.bool,
  selectedAllSharesAllPools: PropTypes.bool,
  selectedCharityEin: PropTypes.string,
  selectedCharityName: PropTypes.string,
  setUserSession: PropTypes.func,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  stepDesc: PropTypes.string,
  userSelectedDateVal: PropTypes.any,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GrantScheduleAllocation)
);
